var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Huge-icon/interface/outline/remove-rectangle",
    clipPath: "url(#clip0_1332_5500)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.64927 6.07404L5.34943 9.37387M8.64927 9.37388L5.34943 6.07404M10.4993 1.89062H3.49935C2.21068 1.89062 1.16602 2.93529 1.16602 4.22396V11.224C1.16602 12.5126 2.21068 13.5573 3.49935 13.5573H10.4993C11.788 13.5573 12.8327 12.5126 12.8327 11.224V4.22396C12.8327 2.93529 11.788 1.89062 10.4993 1.89062Z",
    stroke: "#ED2121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1332_5500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.722656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveRectangle);
export default __webpack_public_path__ + "static/media/remove-rectangle.adaf2c273845235cc7144149c65042f8.svg";
export { ForwardRef as ReactComponent };